import React, { useState } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useQuery } from "react-query"
import WelcomeComp from "./WelcomeComp"
import BarChart from "./BarChart"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import RegistrationByGender from "./RegistrationByGender"
import { GENERAL } from "api/general"
import Swal from "sweetalert2"

// LGA Chairman — view and download own LGA's data only, no management actions
const LgaChairmanDashboard = () => {
  const [dashboardStats, setDashboardStats] = useState(null)

  useQuery({
    queryKey: ["lgaChairmanDashboard"],
    queryFn: () => {
      Swal.fire({
        title: "Loading...",
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(Swal.getDenyButton())
        },
      })
      return GENERAL.getDashboardStatsLga()
    },
    onSuccess: res => {
      Swal.close()
      setDashboardStats(res)
    },
  })

  const genderPieChart = [
    dashboardStats?.applicationByGender?.male || 0,
    dashboardStats?.applicationByGender?.female || 0,
  ]
  const statisticsBarChart = [
    dashboardStats?.totalApprovedAgents || 0,
    dashboardStats?.totalDeclinedAgents || 0,
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboards" breadcrumbItem="LGA Performance" />

          <Row>
            <Col xl="4">
              <WelcomeComp />
              <RegistrationByGender
                dataColors='["--bs-primary", "--bs-success"]'
                periodData={genderPieChart}
              />
              <BarChart
                dataColors='["--bs-primary", "--bs-success"]'
                periodData={statisticsBarChart}
              />
            </Col>
            <Col xl="8">
              <Row>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Total Registrars</p>
                          <h4 className="mb-0 text-primary">
                            {dashboardStats?.totalApplicants || 0}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className="bx bx-copy-alt font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Approved Registrars</p>
                          <h4 className="mb-0 text-success">
                            {dashboardStats?.totalApprovedAgents || 0}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-success">
                            <i className="bx bx-check-double font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Pending Registrars</p>
                          <h4 className="mb-0 text-warning">
                            {dashboardStats?.totalPendingAgents || 0}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-warning">
                            <i className="bx bx-time font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Declined Registrars</p>
                          <h4 className="mb-0 text-danger">
                            {dashboardStats?.totalDeclinedAgents || 0}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-danger">
                            <i className="bx bx-x font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LgaChairmanDashboard
